module.exports = __webpack_public_path__ + "img/service_cloud_6_mob_2x.34a332d4.jpg";